import { useState } from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
  Autoplay,
  Navigation,
  A11y,
  Lazy,
  EffectFade,
  Controller
} from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/a11y';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';

SwiperCore.use([Autoplay, Navigation, Lazy, A11y, EffectFade, Controller]);
export const partnerSteps = [
  {
    header: 'Become Our Partner',
    subheader:
      'Become a valued member of our team and unlock the opportunity to earn through our affiliate program.',
    imageUrl:
      'https://res.cloudinary.com/see-sight-tours/image/upload/v1689857447/Remaining%20images/Partners/Become_Our_Partner_jxhbbl.svg'
  },
  {
    header: 'Promote Us',
    subheader:
      'Spread The Word To Your Audience And Drive Customers To our Website',
    imageUrl:
      'https://res.cloudinary.com/see-sight-tours/image/upload/v1689857446/Remaining%20images/Partners/Promote_Us_fjnhsw.svg'
  },
  {
    header: 'Get Rewarded',
    subheader:
      'Start earning commissions for the traffic you generate by sharing your unique trackable link to the site.',
    imageUrl:
      'https://res.cloudinary.com/see-sight-tours/image/upload/v1690183879/Remaining%20images/Partners/Frame_48095687_1_hhftku.svg'
  }
];

const PartnerStepsMobile = () => {
  return (
    <div className="md:hidden">
      <Swiper
        slidesPerView="auto"
        spaceBetween={5}
        grabCursor
        loop={true}
        lazy={{
          loadPrevNext: false,
          checkInView: true
        }}
        navigation={{ prevEl: '.prevBtn', nextEl: '.nextBtn' }}
        breakpoints={{
          226: {
            slidesPerView: 1
          },
          640: {
            slidesPerView: 1
          }
        }}
      >
        {partnerSteps.map((dt: Record<string, any>, index: number) => (
          <SwiperSlide key={index}>
            <div className="flex flex-col justify-between items-center">
              <div
                id="image-wrapper"
                className="flex-none w-[60%] h-[190px] relative"
              >
                <Image src={dt.imageUrl} fill alt={dt.imageUrl} />
              </div>

              <p className="mt-0 text-base text-[#333333] text-center">
                {dt.header}
              </p>
              <p className=" mt-2 text-sm text-[#828282] text-center px-[6%]">
                {dt.subheader}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex gap-2 justify-center items-center mt-5">
        <button className="flex justify-center items-center text-white bg-[#CCCCCC] rounded-[50%] p-3 w-[35px] h-[35px] prevBtn">
          <Image
            src={
              'https://res.cloudinary.com/see-sight-tours/image/upload/v1686744607/Remaining%20images/Tour/prevslideicon_udvyoi.svg'
            }
            width={15}
            height={15}
            alt="reviews"
          />
        </button>
        <button className="flex justify-center items-center text-white bg-[#F15C5A] rounded-[50%] p-3 w-[35px] h-[35px] nextBtn">
          <Image
            src={
              'https://res.cloudinary.com/see-sight-tours/image/upload/v1686744607/Remaining%20images/Tour/nextslideicon_mb6d6u.svg'
            }
            width={15}
            height={15}
            alt="reviews"
          />
        </button>
      </div>
    </div>
  );
};

export default PartnerStepsMobile;
